var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CacheRouterView'),_c('layout-tabbar',{attrs:{"tab-list":_vm.tabbarList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }